import login from './login';

export default {
  language: 'id',
  country: 'id',
  name: 'Bahasa Indonesia',
  embeddedLocale: login,
};
